import React, {Fragment, useState, useEffect, useContext } from "react";
import Typography from "@mui/material/Typography";

import parse from "html-react-parser";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import Box from '@mui/material/Box'
import { useAppContext } from '../../AppContext';
import { useTheme } from '@mui/material/styles';


function Terms({ data }) { 
    
    const theme = useTheme();
  const { url, themeData, siteData,  themeLoading, siteLoading, themeError, siteError, changeUrl, updateThemeData, updateSiteData } = useAppContext();
    const [themeCss, setThemeCss] = useState(null);
    const [loading, setLoading] = useState(true);
  
    useEffect(()=>{
      let custom_css = themeData && themeData ? JSON.parse(themeData && themeData.custom_css): null;
      setThemeCss(custom_css)
      setLoading(false)
    }, [themeData]);


    const termsCard = {
        // borderTop: `1px solid ${theme.palette.background.borderColor}`,
        borderColor: `${theme.palette.primary.borderColor}`,
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1),
        '& h5': {
            fontFamily: themeCss && themeCss.theme_body_font ? (themeCss.theme_body_font).replace("+"," ") : '',
            fontSize: 14,
            textTransform: 'capitalize',    
            color: theme.palette.primary.contrastText,         
            fontWeight: 400,    
        },
        '& h6': {
            fontFamily: themeCss && themeCss.theme_body_font ? (themeCss.theme_body_font).replace("+"," ") : '',
            fontSize: 16,
            color: theme.palette.primary.location,
            fontWeight: 400,    
        },   
    };
    const accordian = {
        background: 'none',
        boxShadow: 'none',
    }; 
    const accordianSummary = {
        fontFamily: themeCss && themeCss.theme_body_font ? (themeCss.theme_body_font).replace("+"," ") : '',
        fontSize: 14,
        color: theme.palette.primary.location,
        fontWeight: 500,
        padding: 0,    
        '& a': {
            fontFamily: themeCss && themeCss.theme_body_font ? (themeCss.theme_body_font).replace("+"," ") : '',
            fontSize: 14,
            color: theme.palette.primary.location,
            textDecoration:'underline'
        },
        '& span': {
            fontFamily: themeCss && themeCss.theme_body_font ? (themeCss.theme_body_font).replace("+"," ") : '',
            fontSize: 14,
            fontWeight: 100,
        },
        '& h5': {
            fontFamily: themeCss && themeCss.theme_body_font ? (themeCss.theme_body_font).replace("+"," ") : '',
            fontSize: 14,
            fontWeight: 100,
        },
        '& h6': {
            fontFamily: themeCss && themeCss.theme_body_font ? (themeCss.theme_body_font).replace("+"," ") : '',
            fontSize: 14,
            fontWeight: 100,
        },
        '& p': {
            fontFamily: themeCss && themeCss.theme_body_font ? (themeCss.theme_body_font).replace("+"," ") : '',
            fontSize: 14,
            fontWeight: 100,
        },
        '& ul': {
            fontFamily: themeCss && themeCss.theme_body_font ? (themeCss.theme_body_font).replace("+"," ") : '',
            fontSize: 14,
            fontWeight: 100,
            pl:2,
        },
    };
    
  return (
    <>            
        {data.tc.length > 0 ? (
            <Typography component="div" sx={termsCard}>                                  
                <Accordion sx={accordian}>
                    <AccordionSummary
                          expandIcon={
                              <Box
                                sx={{
                                '.Mui-expanded & > .collapsIconWrapper': {
                                    display: 'none',
                                },
                                '.expandIconWrapper': {
                                    display: 'none',
                                },
                                '.Mui-expanded & > .expandIconWrapper': {
                                    display: 'block',
                                },
                                }}
                            >
                                <div className="expandIconWrapper">
                                      <RemoveIcon sx={{fontSize:16, color: theme.palette.primary.location}} />
                                </div>
                                <div className="collapsIconWrapper">
                                    <AddIcon sx={{fontSize:16, color: theme.palette.primary.location}} />
                                </div>
                            </Box>
                        }
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        sx={{ px: 0 }}
                        // classes={{ content: classes.content, expanded: classes.expanded }}                        
                    >
                        <Typography component="h5">Terms</Typography>
                    </AccordionSummary>
                        <AccordionDetails sx={accordianSummary}>
                          {parse(data.tc)} 
                        </AccordionDetails>
                </Accordion>
            </Typography>
        ) : ('')} 
    </>
  );
}

export default Terms;
